const BASE_URL = import.meta.env.VITE_API_URL as string

const TOKEN_KEY = 'qr-token'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

interface ApiOptions {
  method?: string
  body?: unknown
  signal?: AbortSignal
  token?: string | null
}

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const { method = 'GET', body, signal, token = getToken() } = options

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const response = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    signal,
  })

  if (response.status === 204) return undefined as T

  const data = await response.json()

  if (!response.ok) {
    throw new ApiError(response.status, (data as { error?: string }).error ?? `HTTP ${response.status}`)
  }

  return data as T
}

export const get  = <T>(path: string, opts?: Omit<ApiOptions, 'method'>) => api<T>(path, { ...opts, method: 'GET' })
export const post = <T>(path: string, body?: unknown, opts?: Omit<ApiOptions, 'method' | 'body'>) => api<T>(path, { ...opts, method: 'POST', body })
export const put  = <T>(path: string, body?: unknown, opts?: Omit<ApiOptions, 'method' | 'body'>) => api<T>(path, { ...opts, method: 'PUT',  body })
export const del  = <T>(path: string, opts?: Omit<ApiOptions, 'method'>) => api<T>(path, { ...opts, method: 'DELETE' })
